import { useTranslation } from 'react-i18next';

export const keyPrefix = 'event_attributes';
export const useEventAttributesTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    no_data: 'Нет данных',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    no_data: 'No data',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    no_data: 'Sem dados',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    no_data: 'Sin datos',
  },
}) as Record<string, unknown>;
